import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-user-edit',
  templateUrl: './app-user-edit.component.html',
  styleUrls: ['./app-user-edit.component.css']
})
export class AppUserEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
